import classNames from 'classnames';
import { type JSX, ReactNode } from 'react';
import { DropdownMenuOption, DropdownMenuSectionOption, DropdownMenuTextOption } from '../../types';
import DropdownMenuItem from './DropdownMenuItem';
import styles from './styles/styles.module.scss';

const isDropdownMenuTextOption = (option: DropdownMenuOption): option is DropdownMenuTextOption => 'title' in option;
const isDropdownMenuSectionOption = (option: DropdownMenuOption): option is DropdownMenuSectionOption => 'sectionHeader' in option;

type DropdownMenuItemsProps = {
  className?: string;
  children?: ReactNode;
  options: DropdownMenuOption[];
  textVariant?: 'text100' | 'text200';
};

const DropdownMenuItems = ({ className, children, options, textVariant = 'text100' }: DropdownMenuItemsProps): JSX.Element => {
  return (
    <div className={classNames(styles.container, className)}>
      {options.map((option, index) => {
        const key = `option-${index}`;
        if (isDropdownMenuTextOption(option)) {
          return <DropdownMenuItem key={key} option={option} textVariant={textVariant} />;
        }
        if (isDropdownMenuSectionOption(option)) {
          return (
            <div key={key} className={styles.sectionOption}>
              <div key={key} className={styles.sectionDivider} />
              {option.sectionHeader ? <span className={styles.sectionHeader}>{option.sectionHeader}</span> : null}
            </div>
          );
        }
        return option;
      })}
      {children}
    </div>
  );
};

export default DropdownMenuItems;
